import { Skeleton } from 'antd';

import type { FC } from 'react';

import './BranchSelectorSkeleton.scss';

const BRANCH_BUTTON_WIDTHS = [100, 80, 90];

export const BranchSelectorSkeleton: FC = () => (
  <div className="BranchSelectorSkeleton" aria-busy="true" aria-live="polite">
    <div className="BranchSelectorSkeleton__scroll">
      {BRANCH_BUTTON_WIDTHS.map((width, index) => (
        <Skeleton.Button
          className="BranchSelectorSkeleton__branch-button"
          active
          size="default"
          style={{ width }}
          key={index}
        />
      ))}
      <Skeleton.Button
        className="BranchSelectorSkeleton__add-button"
        active
        size="default"
        shape="square"
      />
    </div>
  </div>
);
